module.exports = __webpack_public_path__ + "static/media/dashboardLight_9224.svg";